import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { HistoryPageStateModuleName } from '@/store/modules/modules'

export class HistoryPageStateViewModel {
  private store = useStore()

  historyExpandedList: ComputedRef<{ [judgeId: number]: boolean }> = computed(
    () => this.store.getters[`${HistoryPageStateModuleName}/historyExpandedList`]
  )
  historyLoadingList: ComputedRef<{ [judgeId: number]: boolean }> = computed(
    () => this.store.getters[`${HistoryPageStateModuleName}/historyLoadingList`]
  )
  pageIndex: ComputedRef<number> = computed(() => this.store.getters[`${HistoryPageStateModuleName}/pageIndex`])
  isFirstOpendPage: ComputedRef<boolean> = computed(
    () => this.store.getters[`${HistoryPageStateModuleName}/isFirstOpendPage`]
  )
  isNotMoreHistoryList: ComputedRef<boolean> = computed(
    () => this.store.getters[`${HistoryPageStateModuleName}/isNotMoreHistoryList`]
  )

  setPageIndex(pageIndex: number): void {
    this.store.commit(`${HistoryPageStateModuleName}/setPageIndex`, { pageIndex })
  }

  setIsFirstOpendPage(flag: boolean): void {
    this.store.commit(`${HistoryPageStateModuleName}/setIsFirstOpendPage`, { flag })
  }

  setIsNotMoreHistoryList(flag: boolean): void {
    this.store.commit(`${HistoryPageStateModuleName}/setIsNotMoreHistoryList`, { flag })
  }

  setHistoryExpandedList(list: { [judgeId: number]: boolean }): void {
    this.store.commit(`${HistoryPageStateModuleName}/setHistoryExpandedList`, { list })
  }

  setHistoryExpandedFlag(judgeId: number, flag: boolean): void {
    this.store.commit(`${HistoryPageStateModuleName}/setHistoryExpandedFlag`, { judgeId, flag })
  }

  setHistoryLoadingList(list: { [judgeId: number]: boolean }): void {
    this.store.commit(`${HistoryPageStateModuleName}/setHistoryLoadingList`, { list })
  }

  setHistoryLoadingFlag(judgeId: number, flag: boolean): void {
    this.store.commit(`${HistoryPageStateModuleName}/setHistoryLoadingFlag`, { judgeId, flag })
  }
}
